"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiDeleteMarkByCustomId = exports.apiDeleteMark = exports.apiUpdateMarkByCustomId = exports.apiUpdateMark = exports.apiGetMarksByContentId = exports.apiGetMarks = exports.apiGetMarkByCustomId = exports.apiGetMark = exports.apiAddMark = void 0;
const client_1 = require("./client");
// ======================================================================================
//								     ___   _____   _____
//								    /   | |  _  \ |  _  \
//								   / /| | | | | | | | | |
//								  / / | | | | | | | | | |
//								 / /  | | | |_| | | |_| |
//								/_/   |_| |_____/ |_____/
// ======================================================================================
/**
 * Add a Mark.
 *
 * The markData must include:
 * - `customId`
 * - `contentId
 * - `uniqueText`
 * - `selectionText`
 * - `selectionOffset`
 * - `selectionLength`
 * - `color`
 * The mark automatically gets assigned to the currently signed-in user.
 * @param markData contains the data.
 * @returns the newly created mark.
 */
const apiAddMark = async (markData) => {
    const { data } = await client_1.default.post('/marks/add-mark', markData);
    return data;
};
exports.apiAddMark = apiAddMark;
// ======================================================================================
//									 _____   _____   _____
//									/  ___| | ____| |_   _|
//									| |     | |__     | |
//									| |  _  |  __|    | |
//									| |_| | | |___    | |
//									\_____/ |_____|   |_|
// ======================================================================================
/**
 * Gets the respective Mark based on its ID.
 * @param markId
 */
const apiGetMark = async (markId) => {
    const { data } = await client_1.default.get(`/marks/get-mark/${markId}`);
    return data;
};
exports.apiGetMark = apiGetMark;
/**
 * Gets the respective Mark based on its customId.
 * @param customId
 */
const apiGetMarkByCustomId = async (customId) => {
    const { data } = await client_1.default.get(`/marks/get-mark-by-custom-id/${customId}`);
    return data;
};
exports.apiGetMarkByCustomId = apiGetMarkByCustomId;
/**
 * Gets all marks of the current user (student or teacher)
 * @param after optional after date
 */
const apiGetMarks = async (after) => {
    const { data } = await client_1.default.get('/marks/get-marks', {
        params: Object.assign({}, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiGetMarks = apiGetMarks;
/**
 * Gets all marks of the current user (student or teacher)
 * that relate to the given contentId
 * @param contentId the mark relates to
 * @param after optional after date
 */
const apiGetMarksByContentId = async (contentId, after) => {
    const { data } = await client_1.default.get(`/marks/get-marks-by-content-id/${contentId}`, {
        params: Object.assign({}, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiGetMarksByContentId = apiGetMarksByContentId;
// ======================================================================================
//					 _   _   _____   _____       ___   _____   _____
//					| | | | |  _  \ |  _  \     /   | |_   _| | ____|
//					| | | | | |_| | | | | |    / /| |   | |   | |__
//					| | | | |  ___/ | | | |   / / | |   | |   |  __|
//					| |_| | | |     | |_| |  / /  | |   | |   | |___
//					\_____/ |_|     |_____/ /_/   |_|   |_|   |_____|
// ======================================================================================
/**
 * Updates the given mark of the current user (student or teacher)
 * based on the markId
 * MarkUpdateData fields (all optional):
 * - `customId`
 * - `contentId
 * - `uniqueText`
 * - `selectionText`
 * - `selectionOffset`
 * - `selectionLength`
 * - `color`
 * @param markUpdateData
 * @param markId
 */
const apiUpdateMark = async (markUpdateData, markId) => {
    const { data } = await client_1.default.put(`/marks/update-mark/${markId}`, markUpdateData);
    return data;
};
exports.apiUpdateMark = apiUpdateMark;
/**
 * Updates the given mark of the current user (student or teacher)
 * based on the customId of the mark.
 * MarkUpdateData fields (all optional):
 * - `customId`
 * - `contentId
 * - `uniqueText`
 * - `selectionText`
 * - `selectionOffset`
 * - `selectionLength`
 * - `color`
 * @param markUpdateData
 * @param customId
 */
const apiUpdateMarkByCustomId = async (markUpdateData, customId) => {
    const { data } = await client_1.default.put(`/marks/update-mark-by-custom-id/${customId}`, markUpdateData);
    return data;
};
exports.apiUpdateMarkByCustomId = apiUpdateMarkByCustomId;
// ======================================================================================
//					 _____   _____   _       _____   _____   _____
//					|  _  \ | ____| | |     | ____| |_   _| | ____|
//					| | | | | |__   | |     | |__     | |   | |__
//					| | | | |  __|  | |     |  __|    | |   |  __|
//					| |_| | | |___  | |___  | |___    | |   | |___
//					|_____/ |_____| |_____| |_____|   |_|   |_____|
// ======================================================================================
/**
 * Deletes a mark based on the markId
 * @param markId
 */
const apiDeleteMark = async (markId) => {
    await client_1.default.delete(`/marks/delete-mark/${markId}`);
};
exports.apiDeleteMark = apiDeleteMark;
/**
 * Deletes a mark based on the customId
 * @param customId
 */
const apiDeleteMarkByCustomId = async (customId) => {
    await client_1.default.delete(`/marks/delete-mark-by-custom-id/${customId}`);
};
exports.apiDeleteMarkByCustomId = apiDeleteMarkByCustomId;
// ======================================================================================
//					     ___  ___   _   _____   _____
//					    /   |/   | | | /  ___/ /  ___|
//					   / /|   /| | | | | |___  | |
//					  / / |__/ | | | | \___  \ | |
//					 / /       | | | |  ___| | | |___
//					/_/        |_| |_| /_____/ \_____|
// ======================================================================================
//# sourceMappingURL=marks.js.map